exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-872ecde2]::-webkit-scrollbar-thumb{background:rgba(10,46,225,.9)!important}", ""]);

// exports
